module.exports = __webpack_public_path__ + "static/media/elife-redemption-event.0afd6ad3.png";